/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import dayjs, { Dayjs } from 'dayjs';
import type { MutationsObject } from '@kp/js-model';

export class DownloadCount extends BaseModel {
    // properties
    id: number | null = null;
    filename: string | null = null;
    count: string | null = null;
    letzter_download: Dayjs | null = null;

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            letzter_download: dayjs
        };
    }

    getClassName(): string {
        return 'downloadcount';
    }
}

export class DownloadCountCollection extends BaseCollection<DownloadCount> {
    protected modelCls = DownloadCount;

    public getModelClassName(): string {
        return 'downloadcount';
    }
}
